import { Component } from '@angular/core';
import { TextAlign } from '@app/features/app-content/models/app-tabs.model';
import { UpdateAppConfig } from '@app/features/app-content/states/app-configuration.actions';
import { AppConfigurationState } from '@app/features/app-content/states/app-configuration.state';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-text-align-settings',
  templateUrl: './text-align-settings.component.html',
  styleUrl: './text-align-settings.component.scss',
  standalone: false,
})
export class TextAlignSettingsComponent {
  @Select(AppConfigurationState.textAlign)
  textAlign$: Observable<TextAlign>;

  alignments: TextAlign[] = ['left', 'center', 'right', 'justify'];
  iconMap: { [key: string]: IconProp } = {
    left: 'align-left',
    center: 'align-center',
    right: 'align-right',
    justify: 'align-justify',
  };

  constructor(private readonly store: Store) {}

  selectTextAlign(textAlign: TextAlign) {
    this.store.dispatch(new UpdateAppConfig(['onglets', '0', 'textAlign'], textAlign));
  }
}
